/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1801
 */

var r = require(/* 1287 */"./1287")
module.exports = function (e) {
  if (Array.isArray(e)) {
    return r(e)
  }
}
